// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "mamae-completa-edm.firebaseapp.com",
  "projectId": "mamae-completa-edm",
  "storageBucket": "mamae-completa-edm.appspot.com",
  "messagingSenderId": "777536674558",
  "appId": "1:777536674558:web:efa021937ceb76598de3af",
  "measurementId": "G-0S6774HLWQ",
  "apiKey": "AIzaSyCRP5uxqx8zLazhegSdwiZrIlaidbIPQow"
};
